export const blockIconsAndroidRadarNew = (
	<span className='material-symbols-outlined'>radar</span>
);
